import Typography from '@mui/material/Typography'
import { colors } from '@theme/variables'

import { ErrorIcon, ValidationErrorContainer } from './index.styles'

const ErrorMessage = ({ error }: { error?: string }) => {
  return error ? (
    <ValidationErrorContainer>
      <ErrorIcon htmlColor={colors.error} fontSize="small" />
      <Typography variant="body1">{error}</Typography>
    </ValidationErrorContainer>
  ) : null
}

export default ErrorMessage
